package org.catharsis.spendtel.feature.presentation.publicshare

import androidx.compose.runtime.Composable
import org.catharsis.spendtel.feature.presentation.web.WebPublicShareScreen

@Composable
actual fun PlatformPublicShareScreen(shareId: String) {
    WebPublicShareScreen(shareId = shareId)
}
